import escape from 'lodash-es/escape';
import includes from 'lodash-es/includes';
import { getProductInventories } from '../../core/productInfo';

export default (product_details) => {
  setTimeout(() => {
    const product_reviews = document.querySelector('[data-reviews-average]').dataset;
    const product_inventories = getProductInventories();

    const admind_product = {
      id: product_details.product.id,
      variant: product_details.currentVariant.id,
      style: escape(product_details.currentVariant.barcode),
      // category: ,
      subcategory: escape(product_details.product.type),
      name: escape(product_details.product.title),
      price: Number((product_details.currentVariant.price / 100).toFixed(2)),
      originalPrice: Number((product_details.currentVariant.compare_at_price / 100).toFixed(2)),
      newArrival: includes(product_details.product.tags, 'New Arrival'),
      isMarkedDown: product_details.currentVariant.price < product_details.currentVariant.compare_at_price,
      hasReviews: parseInt(product_reviews.reviewsCount) > 0,
      reviewCount: parseInt(product_reviews.reviewsCount) || 0,
      reviewAverage: parseFloat(product_reviews.reviewsAverage) || 0,
      showsQuadpay: product_details.currentVariant.price > 1900,
      almostGone: product_inventories[product_details.currentVariant.id] < 10,
    };

    const dataLayer = window.dataLayer || [];

    dataLayer.push({
      event: 'detail',
      ecommerce: {
        detail: {
          products: [admind_product],
        },
      },
    });
  });
};
